// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.approval-attachments {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.approval-attachments__layout {
  display: grid;
  grid-template-columns: 288px minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
}

.approval-attachments__layout--single {
  grid-template-columns: minmax(0, 1fr);
}

.approval-attachments__rail {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 62vh;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.approval-attachments__rail-label {
  color: #475467;
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.approval-attachments__item {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 32px;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  text-align: left;
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid transparent;
  border-radius: 8px;
  padding: 0.625rem 0.75rem;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
}

.approval-attachments__item:hover {
  background: #f8fafc;
}

.approval-attachments__item--active {
  background: #f8fafc;
  border-left-color: #1d2939;
}

.approval-attachments__item-icon {
  color: #667085;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.approval-attachments__item-name {
  color: #1d2939;
  font-weight: 500;
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-attachments__item-name--link {
  color: #0b63ce;
  text-decoration: underline;
  cursor: pointer;
}

.approval-attachments__item-name--link:hover {
  color: #084a9a;
}

.approval-attachments__item-meta {
  color: #667085;
  font-size: 0.72rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-attachments__icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #667085;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.approval-attachments__icon-button:hover {
  background: #eef2f6;
  color: #1d2939;
}

.approval-attachments__viewer {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.approval-attachments__viewer--collapsed .approval-attachments__viewer-header {
  border-bottom: none;
}

.approval-attachments__viewer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f3f5;
}

.approval-attachments__viewer-toggle {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
  flex: 1 1;
  padding: 0;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.approval-attachments__viewer-toggle:hover .approval-attachments__viewer-name {
  color: #101828;
}

.approval-attachments__viewer-title {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
}

.approval-attachments__viewer-name {
  color: #1d2939;
  font-weight: 600;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-attachments__viewer-meta {
  color: #667085;
  font-size: 0.72rem;
}

.approval-attachments__chevron {
  flex-shrink: 0;
  color: #667085;
  font-size: 18px;
  transition: transform 0.15s ease;
}

.approval-attachments__chevron--open {
  transform: rotate(180deg);
}

.approval-attachments__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  max-height: 62vh;
  padding: 1rem;
  background: #f8fafc;
}

.approval-attachments__stage img {
  max-width: 100%;
  max-height: 58vh;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
}

.approval-attachments__stage iframe {
  width: 100%;
  height: 58vh;
  border: none;
  border-radius: 6px;
  background: #fff;
}

.approval-attachments__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #667085;
  font-size: 0.85rem;
}

.approval-attachments__spinner {
  width: 22px;
  height: 22px;
  border: 2px solid #e4e7ec;
  border-top-color: #1d2939;
  border-radius: 50%;
  animation: approval-attachments-spin 0.7s linear infinite;
}

@keyframes approval-attachments-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 992px) {
  .approval-attachments__layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .approval-attachments__rail {
    max-height: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/ApprovalAttachmentsModal/attachments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf;;2BAEyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,SAAO;EACP,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".approval-attachments {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.approval-attachments__layout {\n  display: grid;\n  grid-template-columns: 288px minmax(0, 1fr);\n  gap: 1rem;\n  align-items: start;\n}\n\n.approval-attachments__layout--single {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.approval-attachments__rail {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 62vh;\n  overflow-y: auto;\n  padding-right: 0.25rem;\n}\n\n.approval-attachments__rail-label {\n  color: #475467;\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.approval-attachments__item {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr) 32px;\n  align-items: center;\n  gap: 0.625rem;\n  width: 100%;\n  text-align: left;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-left: 3px solid transparent;\n  border-radius: 8px;\n  padding: 0.625rem 0.75rem;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.approval-attachments__item:hover {\n  background: #f8fafc;\n}\n\n.approval-attachments__item--active {\n  background: #f8fafc;\n  border-left-color: #1d2939;\n}\n\n.approval-attachments__item-icon {\n  color: #667085;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n}\n\n.approval-attachments__item-name {\n  color: #1d2939;\n  font-weight: 500;\n  font-size: 0.85rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.approval-attachments__item-name--link {\n  color: #0b63ce;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.approval-attachments__item-name--link:hover {\n  color: #084a9a;\n}\n\n.approval-attachments__item-meta {\n  color: #667085;\n  font-size: 0.72rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.approval-attachments__icon-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #667085;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.approval-attachments__icon-button:hover {\n  background: #eef2f6;\n  color: #1d2939;\n}\n\n.approval-attachments__viewer {\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.approval-attachments__viewer--collapsed .approval-attachments__viewer-header {\n  border-bottom: none;\n}\n\n.approval-attachments__viewer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f3f5;\n}\n\n.approval-attachments__viewer-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  min-width: 0;\n  flex: 1;\n  padding: 0;\n  border: none;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n}\n\n.approval-attachments__viewer-toggle:hover .approval-attachments__viewer-name {\n  color: #101828;\n}\n\n.approval-attachments__viewer-title {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  min-width: 0;\n}\n\n.approval-attachments__viewer-name {\n  color: #1d2939;\n  font-weight: 600;\n  font-size: 0.9rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.approval-attachments__viewer-meta {\n  color: #667085;\n  font-size: 0.72rem;\n}\n\n.approval-attachments__chevron {\n  flex-shrink: 0;\n  color: #667085;\n  font-size: 18px;\n  transition: transform 0.15s ease;\n}\n\n.approval-attachments__chevron--open {\n  transform: rotate(180deg);\n}\n\n.approval-attachments__stage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 320px;\n  max-height: 62vh;\n  padding: 1rem;\n  background: #f8fafc;\n}\n\n.approval-attachments__stage img {\n  max-width: 100%;\n  max-height: 58vh;\n  object-fit: contain;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.approval-attachments__stage iframe {\n  width: 100%;\n  height: 58vh;\n  border: none;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.approval-attachments__state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  color: #667085;\n  font-size: 0.85rem;\n}\n\n.approval-attachments__spinner {\n  width: 22px;\n  height: 22px;\n  border: 2px solid #e4e7ec;\n  border-top-color: #1d2939;\n  border-radius: 50%;\n  animation: approval-attachments-spin 0.7s linear infinite;\n}\n\n@keyframes approval-attachments-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 992px) {\n  .approval-attachments__layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .approval-attachments__rail {\n    max-height: 220px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
